import { useState, useEffect, useCallback } from 'react';
import axios from '../../axiosConfig';

/**
 * Custom hook for fetching and managing owner dashboard data
 * Returns data for all dogs including:
 * - Soonest upcoming training
 * - Exercise completion statistics
 * - Pending reports and surveys
 */
const useOwnerDashboard = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getAuthHeader = useCallback(() => {
        const token = localStorage.getItem('jwt');
        return token ? { Authorization: `Bearer ${token}` } : {};
    }, []);

    const fetchDashboardData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get('/api/v1/owner/dashboard', {
                headers: getAuthHeader(),
            });
            setDashboardData(response.data);
        } catch (err) {
            console.error('Failed to fetch dashboard data:', err);
            setError(err.response?.data?.message || 'Nie udało się pobrać danych panelu');
        } finally {
            setLoading(false);
        }
    }, [getAuthHeader]);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    const refresh = useCallback(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    return {
        dashboardData,
        loading,
        error,
        refresh,
    };
};

export default useOwnerDashboard;